import { RootState, ThunkDispatch } from "core-integration/src/store";
import { getElementsById } from "core-integration/src/store/elements/reducers";
import { showElementSummary } from "core-integration/src/store/elements/thunks";
import { IElementsById } from "core-integration/src/store/elements/types";
import { IPickLight } from "core-integration/src/store/entries/types";
import { getFixturesStatusForTeamInEvent } from "core-integration/src/store/fixtures/reducers";
import * as React from "react";
import { connect, useSelector } from "react-redux";
import styled from "styled-components";
import { getElementValueBarVariant } from "../../utils/getElementValueBarVariant";
import ElementDialogButton from "../ElementDialogButton";
import ElementShirt from "../ElementShirt";
import ElementValueBar from "../ElementValueBar";
import { Controls } from "../Pitch";
import { UnstyledButton } from "../Utils";
import StatusPitchElementData from "./StatusPitchElementData";

const StatusPitchElementWrap = styled.div`
  margin: 0 0.2rem;
  padding: 0.4rem 0;
  border-radius: 0.4rem;
  align-items: stretch;
`;

const StyledStatusPitchElement = styled.div`
  position: relative;
  width: 6rem;
  margin: auto;
  padding-inline-end: 0.3rem;
  padding-inline-start: 0.3rem;
  text-align: center;

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    width: 7rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    width: 10.5rem;
  }
`;

const StyledInfoControl = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    position: absolute;
    top: 0;
    right: 5px;
  }
`;

interface IPropsFromState {
  elementsById: IElementsById;
}

interface IPropsFromDispatch {
  showElementDialog: (elementId: number) => void;
}

interface IOwnProps {
  eventId: number;
  pick: IPickLight;
  renderElementMenu: () => void;
  renderPickValue: (pick: IPickLight) => React.ReactNode;
}

type Props = IPropsFromState & IPropsFromDispatch & IOwnProps;

const Squad: React.FC<Props> = ({
  eventId,
  pick,
  elementsById,
  renderElementMenu,
  renderPickValue,
}) => {
  const element = elementsById[pick.element];

  const fixturesStatus = useSelector((state: RootState) =>
    getFixturesStatusForTeamInEvent(state, eventId, element.team),
  );
  const variant = getElementValueBarVariant(fixturesStatus);

  return (
    <StatusPitchElementWrap>
      <StyledStatusPitchElement>
        <UnstyledButton type="button" onClick={renderElementMenu}>
          <ElementShirt
            elementId={element.id}
            hasShadow={true}
            sizes="(min-width: 1024px) 44px, 33px"
          />
          <ElementValueBar variant={variant}>
            <StatusPitchElementData
              element={element}
              value={renderPickValue(pick)}
            />
          </ElementValueBar>
        </UnstyledButton>
        <Controls>
          <StyledInfoControl>
            <ElementDialogButton elementId={pick.element} />
          </StyledInfoControl>
        </Controls>
      </StyledStatusPitchElement>
    </StatusPitchElementWrap>
  );
};

const mapStateToProps = (state: RootState): IPropsFromState => ({
  elementsById: getElementsById(state),
});

const mapDispatchToProps = (dispatch: ThunkDispatch): IPropsFromDispatch => ({
  showElementDialog: (elementId) => dispatch(showElementSummary(elementId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Squad);
